/**
 *  NO IMPORTS ALLOWED!
 * This script runs in <head> before the app loads.
 * It must be standalone to avoid blocking 'vendor' chunks.
 * Use 'import type' only. Copy-paste logic if needed.
 */

import type { PaletteMode } from '@mui/material';

import { preferredThemeModeLocalStorageKey } from '/constants/themeConstants';
import { setThemeModeStylingMetadata } from '/helpers/themeModeStylingMetadataSettingHelper';

function initThemeModeSystemPreferences() {
  handleThemeModeSystemPreferencesInitialization(
    doesSystemHaveDarkThemeSetAsDefault() ? 'dark' : 'light',
    preferredThemeModeLocalStorageKey
  );
}

function handleThemeModeSystemPreferencesInitialization(
  themeModePreferredBySystem: PaletteMode,
  localStorageKey: string
) {
  const preferredThemeMode = localStorage.getItem(preferredThemeModeLocalStorageKey) as PaletteMode | null;
  let targetThemeMode: PaletteMode | null = null;

  if (!preferredThemeMode) {
    localStorage.setItem(localStorageKey, themeModePreferredBySystem);
  } else {
    targetThemeMode = preferredThemeMode;
  }

  setThemeModeStylingMetadata(targetThemeMode || themeModePreferredBySystem);
}

function doesSystemHaveDarkThemeSetAsDefault(): boolean {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

initThemeModeSystemPreferences();
